export default "__VITE_ASSET__bt7Y46DP__"